<template>
    <div id="thank-you-wrap">
  
      <!-- Thank You Modal -->
      <div class="thank-you-modal">
        <div class="modal-content">
          <p>Thank you for your purchase!</p>
          <p>You can view your newly purchased licenses in the "My licenses" section of your account and download them in the "Download" section. This window will close in <span>{{ counter }}</span> seconds.</p>
          <ModalMessage :message="feedbackMessage" :type="feedbackType" />
        </div>
        <div class="button-group">
          <input type="button" @click="closeModal" class="fa-btn fa-btn-primary fa-btn-modal" value="Close Now">
        </div>
      </div>
  
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, computed } from 'vue';
  import { MessageType } from '@/types/enums.ts';
  import { ModalTypes } from '@/types/enums';
  import { useUIStore } from '@/store/uiStore';
  import { useUserStore } from '~/store/userStore';

  import useGTag from '~/composables/useGTag';

  const { 
    trackPurchaseCompleted
  } = useGTag();

  const userStore = useUserStore();
  
  const feedbackMessage = ref(''); // Placeholder if there are any dynamic messages to be displayed.
  const feedbackType = ref(MessageType.INFO);
  const isLoggedIn = computed(() => { return userStore.userData?.is_logged_in || false; });
  
  const uiStore = useUIStore();
  let counter = ref(10);
  
  function closeModal() {
    if(isLoggedIn.value)
      uiStore.setModalType(ModalTypes.INACTIVE);
    else
      uiStore.setModalType(ModalTypes.LOGIN);
  }
  
  // Close the modal after 10 seconds
  onMounted(() => {
    const interval = setInterval(() => {
      if (counter.value > 0) {
        counter.value--;
      } else {
        clearInterval(interval);
        closeModal();
      }
    }, 1000);
    trackPurchaseCompleted();  // TODO: transactionIds
  });
  </script>
  
  <style lang="scss" scoped>
  @import '~/assets/constants.scss';
  
  .thank-you-modal {
    padding: 20px;
    border-radius: $fa-border-radius;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  .button-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  </style>
  